module.exports = __webpack_public_path__ + "media/images/img2-62c2189cf89c7e06e7ef3fb96db45c54.png";